






















import Vue from 'vue'
import Component from 'vue-class-component'
import Particles from '@/components/Particles.vue'

@Component({
  name: 'Introduction',
  components: {
    Particles
  }
})
export default class Introduction extends Vue {
  delays: any

  constructor () {
    super()
    this.delays = {
      title: 500,
      subtitle: 200,
      icons: 1000
    }
  }

  mounted () {
    let sum = 0
    for (const delay in this.delays) {
      sum += this.delays[delay]
      setTimeout(() => {
        this.delays[delay] = 0
      }, sum)
    }
  }
}
